import { StateRepository } from '@angular-ru/ngxs/decorators';
import { Inject, Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { State, StateToken, Store } from '@ngxs/store';
import { ConfirmationService } from 'primeng/api';
import { combineLatest, from, Observable } from 'rxjs';
import { filter, first, map, switchMap, take } from 'rxjs/operators';
import {
    IProductCategoryContext,
    IProductContextAssessmentStatus,
    IProductContextCase,
    IProductContextCaseStatus,
    IProductContextMetadataOwner,
    IProductSmartActionReference,
    IProductStage,
    MedicaidType
} from 'src/app/models/case';
import { INotification } from 'src/app/models/notifications';
import { Product } from 'src/app/models/product';
import { Role } from 'src/app/models/role';
import { SignalREvent } from 'src/app/models/signalr';
import { IDisqualificationReason, IInterviewHandler, IInterviewResult } from 'src/app/shared/interview-new/models/interview-handler.models';
import { AssessmentType } from 'src/app/shared/interview-new/models/interview.models';
import { InterviewHandlerService } from 'src/app/shared/interview-new/services/interview-handler.service';
import { FeatureService } from 'src/app/shared/preview-feature/preview-feature.service';
import { BaseProductServiceSingle } from '../-base-product.service-single';
import { SmartActionContext } from '../../../models/smart-actions.models';
import { CaseService } from '../../case/case.service';
import { interviewMedicaidDataProviderToken } from '../../interview-providers/interview-data-provider.tokens';
import { MemberService } from '../../member/member.service';
import { ProductContextService } from '../../product-context/product-context.service';
import { UserService } from '../../user/user.service';
import { StageTrackerStandardContexts } from '../product-smart-actions';
import { IProductInterviewConfig } from './../../../models/case';
import { AlertService } from './../../alert.service';
import { TaskServiceFactory, TaskServiceFactoryFn } from './../../task/task.service';
import { MedicaidInterviewData } from './medicaid-interview-data';
import {
    MedicaidStateModel, MEDICAID_TOKEN_TOKEN,
    ProductNamePartialToFull,
} from './medicaid.state.models';
import { TaskOrchestratorService } from 'src/app/services/task-orchestrator/task-orchestrator.service';


@StateRepository()
@State<MedicaidStateModel>({
    name: MEDICAID_TOKEN_TOKEN,
    defaults: {

    }
})
@Injectable()
export class MedicaidService extends BaseProductServiceSingle<MedicaidStateModel> {
    productStateToken: StateToken<MedicaidStateModel> = MEDICAID_TOKEN_TOKEN;

    get stateToken() {
        return MEDICAID_TOKEN_TOKEN;
    }


    // get status$(): Observable<IProductContextCaseStatus> {
    //     return this.store.select<IProductContextCaseStatus>(MedicaidService.status(this));
    // }

    // get statusSync(): IProductContextCaseStatus {
    //     return this.store.selectSnapshot<IProductContextCaseStatus>(MedicaidService.status(this));
    // }

    // get caseOwner$(): Observable<IProductContextMetadataOwner> {
    //     return this.store.select<IProductContextMetadataOwner>(MedicaidService.owner(this));
    // }

    // get caseOwnerSync(): IProductContextMetadataOwner {
    //     return this.store.selectSnapshot<IProductContextMetadataOwner>(MedicaidService.owner(this));
    // }

    // get sourceProduct$(): Observable<Product> {
    //     return this.store.select<Product>(MedicaidService.sourceProduct(this));
    // }

    // get productCategoryContext$(): Observable<IProductCategoryContext> {
    //     return this.store.select<IProductCategoryContext>(MedicaidService.productCategoryContext(this));
    // }

    // get productCategoryContextSync(): IProductCategoryContext {
    //     return this.store.selectSnapshot<IProductCategoryContext>(MedicaidService.productCategoryContext(this));
    // }

    // get metadataSync(): any/*IProductCategoryMetadata*/ {
    //     return this.store.selectSnapshot<any>(MedicaidService.metadata);
    // }
    // get metadata$(): Observable<any> {
    //     return this.store.select<any>(MedicaidService.metadata);
    // }

    // get currentCaseSync(): IProductContextCase {
    //     return this.store.selectSnapshot<IProductContextCase>(MedicaidService.currentCase(this));
    // }


    // get currentCase$(): Observable<IProductContextCase> {
    //     return this.store.select<IProductContextCase>(MedicaidService.currentCase(this));
    // }

    // get caseStageSync(): IProductStage {
    //     return this.store.selectSnapshot<IProductStage>(MedicaidService.caseStage(this));
    // }
    // get caseStage$(): Observable<IProductStage> {
    //     return this.store.select<IProductStage>(MedicaidService.caseStage(this));
    // }

    // get notifications$(): Observable<INotification[]> {
    //     return this.store.select<INotification[]>(MedicaidService.notifications(this));
    // }

    // get productInterviewsSync(): IProductInterviewConfig[] {
    //     return this.store.selectSnapshot<IProductInterviewConfig[]>(MedicaidService.productInterviews(this));
    // }

    // get productInterviews$(): Observable<IProductInterviewConfig[]> {
    //     return this.store.select<IProductInterviewConfig[]>(MedicaidService.productInterviews(this));
    // }



    // get caseAssessmentSync(): IProductContextAssessmentStatus {
    //     return this.store.selectSnapshot<IProductContextAssessmentStatus>(MedicaidService.caseAssessment(this));
    // }
    // get caseAssessment$(): Observable<IProductContextAssessmentStatus> {
    //     return this.store.select<IProductContextAssessmentStatus>(MedicaidService.caseAssessment(this));
    // }


    // get iconSync(): string {
    //     return this.store.selectSnapshot<string>(MedicaidService.icon(this));
    // }
    // get icon$(): Observable<string> {
    //     return this.store.select<string>(MedicaidService.icon(this));
    // }

    // get noCaseMessageSync(): string {
    //     return this.store.selectSnapshot<string>(MedicaidService.noCaseMessage(this));
    // }
    // get noCaseMessage$(): Observable<string> {
    //     return this.store.select<string>(MedicaidService.noCaseMessage(this));
    // }

    // get categoryDisplayNameSync(): string {
    //     return this.store.selectSnapshot<string>(MedicaidService.categoryDisplayName(this));
    // }
    // get categoryDisplayName$(): Observable<string> {
    //     return this.store.select<string>(MedicaidService.categoryDisplayName(this));
    // }

    // get stagesSync(): IProductStage[] {
    //     return this.store.selectSnapshot<IProductStage[]>(MedicaidService.stages(this));
    // }
    // get stages$(): Observable<IProductStage[]> {
    //     return this.store.select<IProductStage[]>(MedicaidService.stages(this));
    // }

    // get smartActionsSync(): IProductSmartActionReference[] {
    //     return this.store.selectSnapshot<IProductSmartActionReference[]>(MedicaidService.smartActions(this));
    // }
    // get smartActions$(): Observable<IProductSmartActionReference[]> {
    //     return this.store.select<IProductSmartActionReference[]>(MedicaidService.smartActions(this));
    // }



    get interviewDataProviderToken() {
        return interviewMedicaidDataProviderToken;
    }

    constructor(
        memberService: MemberService,
        userService: UserService,
        protected caseService: CaseService,
        productContextService: ProductContextService,
        confirmationService: ConfirmationService,
        router: Router,
        route: ActivatedRoute,
        alertService: AlertService,
        store: Store,
        featureService: FeatureService,
        taskOrchestratorService: TaskOrchestratorService,
        @Inject(TaskServiceFactory) taskService: TaskServiceFactoryFn
    ) {
        super(
            'Medicaid',
            memberService,
            userService,
            caseService,
            productContextService,
            confirmationService,
            router,
            route,
            alertService,
            MedicaidInterviewData,
            store,
            featureService,
            new InterviewHandlerService(),
            taskOrchestratorService
        );

        this.taskService = taskService().setContext();
        this.taskService.activate();
    }

    getMedicaidType(medicaidType: string): string {
        const enumItem = Object.getOwnPropertyNames(MedicaidType).find(prop => MedicaidType[prop] === medicaidType);
        return enumItem;
    }

    signalRFilter(event: SignalREvent): boolean {
        return true;
    }

    medicaidSmartActions(productCaseNew: IProductContextCase, sourceProduct: Product, userRole?: Role): Observable<SmartActionContext> {
        return StageTrackerStandardContexts.noAction(this);
    }

    recertificationSmartActions(productCaseNew: IProductContextCase, sourceProduct: Product, userRole?: Role): Observable<SmartActionContext> {
        return StageTrackerStandardContexts.noAction(this);
    }

    partialToFullSmartActions(productCaseNew: IProductContextCase, sourceProduct: Product, userRole?: Role): Observable<SmartActionContext> {
        return StageTrackerStandardContexts.noAction(this);
    }

    public async showSendAr(): Promise<boolean> {
        const product = await this.sourceProduct$.pipe(take(1)).toPromise();
        return !!product && product.name.toUpperCase() === 'PARTIALTOFULL';
    }

    formatInterviewResult(interviewHandler: InterviewHandlerService): Observable<IInterviewResult> {
        return combineLatest([interviewHandler.events.evaluationResult$.asObservable(), this.sourceProduct$, this.currentCase$]).pipe(map(([evaluationResult, sourceProduct, productCaseNew]) => {
            const result = evaluationResult && JSON.parse(JSON.stringify(evaluationResult.interviews[0])) as IInterviewResult;
            if (sourceProduct.name.toUpperCase() === ProductNamePartialToFull && productCaseNew.stage.destination === AssessmentType.Eligibility && interviewHandler.completed) {
                result.qualificationResultItems = result.qualificationResultItems && result.qualificationResultItems.filter(item => item.type === 'ABD');
            }

            return result;
        }));
    }

    async canInterviewAdvanceStage(status: string, disqualificationReason: IDisqualificationReason, interviewHandler: IInterviewHandler) {

        // let allow: boolean = true;

        // switch (this.currentCaseSync.productName.toUpperCase()) {
        //     case ProductNameMedicaid:
        //         allow = this.caseStageSync.name === 'Eligibility' || this.caseStageSync.name === 'AwaitingInterview';
        //         break;

        //     case ProductNamePartialToFull:
        //         {
        //             //TODO: [CROSA] Add P2F/Recert allow complete rules
        //             allow = this.caseStageSync.name === 'Initialization' || this.caseStageSync.name === 'Engaging' || this.caseStageSync.name === 'AwaitingInterview';
        //             break;
        //         }
        //     case ProductNameRetention:
        //     case ProductNameManagedRetention:
        //         allow = this.caseStageSync.name === 'Initialization' || this.caseStageSync.name === 'Engaging';
        //         break;
        // }

        return false;
    }

    async finalizeInterview(interviewHandler: InterviewHandlerService) {

        // const [sourceProduct, interviewResult] = await combineLatest([this.sourceProduct$, this.formatInterviewResult(interviewHandler)]).pipe(filter(([a, b]) => !!a && !!b), first()).toPromise();

        // if (sourceProduct.name.toUpperCase() === ProductNameManagedRetention && this.memberService.memberSync.primaryAddress?.state.toUpperCase() === 'AZ') {
        //     // refresh all products without processing advance stage which should happen in the backend
        //     return this.productOrchestratorService.refreshAll();
        // }

        // let status: string = null;
        // let disqualificationReason: IDisqualificationReason = null;

        // // for P2F just care about ABD disqualification
        // if (sourceProduct.name.toUpperCase() === ProductNamePartialToFull) {
        //     if (interviewHandler.settings.type?.toUpperCase() == 'ELIGIBILITY') {
        //         const abdItem = interviewResult.qualificationResultItems.find(i => i.type === 'ABD');
        //         disqualificationReason = (abdItem.disqualifications || []).find(reason => reason.severity.toLocaleUpperCase() === 'ERROR');
        //         status = abdItem.status.toUpperCase();
        //     }
        //     else if (interviewHandler.settings.type?.toUpperCase() == 'EDUCATION') {
        //         return this.productOrchestratorService.refreshAll();
        //     }
        // }

        // const parsed = this.parseInterviewResult(interviewResult, status, disqualificationReason);
        // status = parsed.status;
        // disqualificationReason = parsed.disqualificationReason;

        // await this.interviewAdvanceCaseStage(status, disqualificationReason, interviewHandler);

        return this.productOrchestratorService.refreshAll();
    }

    addCase(): Observable<IProductContextCase> {
        return this.caseService.addCase(this.memberService.base64Sync, this.caseCreateProductType, { CaseType: 'New', Source: 'User' }).pipe(switchMap(_ => {
            return from(this.getCurrentProductContext());
        }));
    }

    get caseCreateProductType() {
        return this.productCategoryContextSync.caseCreateProductType ?? 'Medicaid';
    }
}
